export default __webpack_public_path__ + "static/media/Hair_19_F_C1.9bb7bcfa.svg";